/* src/app/shared/ui-kit/pa-table-array-cell/pa-table-array-cell.component.scss */
.array-container {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  align-items: center;
}
.array-container .array-item {
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: var(--text-default);
}
.array-container .array-more {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background-color: var(--secondary-subtle-default);
  color: var(--secondary-subtle-inverse);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.1s ease-in-out;
}
.array-container .array-more:hover {
  background-color: var(--secondary-subtle-hover);
}
.array-container .array-more:active {
  background-color: var(--secondary-subtle-default);
}
.array-container .array-more:focus-visible {
  outline-color: var(--p-button-secondary-focus-ring-color);
  box-shadow: 0 0 0 0.2rem var(--secondary-subtle-hover);
  outline: var(--p-button-focus-ring-width) var(--p-button-focus-ring-style) var(--p-button-primary-focus-ring-color);
  outline-offset: var(--p-button-focus-ring-offset);
}
/*# sourceMappingURL=pa-table-array-cell.component.css.map */
